import { useHotelSearchNoResult } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-no-result/hotel-search-no-result.hook";
import { HotelSearchNoResultPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-no-result/hotel-search-no-result.types";
import SearchNoResult from "@website/accommodation-ui/hotel-search/hotel-search-panel/images/search-no-result.png";
import { LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const HotelSearchNoResult: FC<HotelSearchNoResultPropertiesType> = (
  properties
) => {
  const { resultTitle, notFoundtitle, firstDescription, secondDescription } =
    useHotelSearchNoResult(properties);

  return (
    <div className="my-6 flex flex-col items-center px-6">
      <div className="text-subtitle-2 text-on-surface-medium-emphasis w-full text-right">
        {resultTitle}
      </div>
      <LazyImage alt="no result" loading="eager" src={SearchNoResult.src} />
      <div className="text-subtitle-1 text-on-surface-high-emphasis mt-6">
        {notFoundtitle}
      </div>
      <div className="text-caption text-on-surface-medium-emphasis mt-2">
        {firstDescription}
      </div>
      <div className="text-caption text-on-surface-medium-emphasis mt-2">
        {secondDescription}
      </div>
    </div>
  );
};

const HotelSearchNoResultMemoized = memo(HotelSearchNoResult, deepCompare);
export { HotelSearchNoResultMemoized as HotelSearchNoResult };
